module.exports = __webpack_public_path__ + "img/apprehension3.7d29d49d.jpg";